module.exports = __webpack_public_path__ + "assets/img/tit1.ffd48974.png";